module.exports = __webpack_public_path__ + "7bee7450d1f04f974ff57f7cd7632f9f.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/mobile_spot.mp4
// module id = 231
// module chunks = 0